import { isEmpty, isNil } from "lodash-es";
import removeAccents from "remove-accents";

export const softContains = (value: string, substring = "") =>
  removeAccents(value.toLowerCase()).includes(removeAccents(substring.toLowerCase()));

const defaultCollator = Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

export const equalsCaseInsensitive = (a: string, b: string) => defaultCollator.compare(a, b) === 0;

export const toSingleValue = (value: string | string[]) => (Array.isArray(value) ? value[0] : value);

export const compareByLocale = defaultCollator.compare;

export const letterForNumber = (value: number): string => {
  const quotient = Math.floor(value / 26);
  return quotient >= 0 ? letterForNumber(quotient - 1) + String.fromCodePoint(65 + (value % 26)) : "";
};

export const isNotEmpty = (value?: string | null): value is string => !isNil(value) && !isEmpty(value.trim());

export const normalize = (value: string): string =>
  value
    .normalize("NFD") // split accents from letters
    .replace(/\p{Diacritic}/gu, "") // remove accents
    .replace(/\s+/g, " ") // collapse whitespace
    .trim()
    .toLowerCase();
